import Immutable from 'immutable';

export default Immutable.Record({
  href: '',
  templated: true,
});
